import Header1 from "../app/common/header/header1";
import CandidateRoutes from "../routing/candidate-routes";
import SignUpPopup from "../app/common/popups/popup-signup";
import SignInPopup from "../app/common/popups/popup-signin";
import CanSidebarSection from "../app/pannels/candidate/sections/common/can-sidebar";
// import InnerPageBanner from "../app/common/inner-page-banner";
import Footer1 from "../app/common/footer/footer1";
import YesNoPopup from "../app/common/popups/popup-yes-no";
import { popupType } from "../globals/constants";
// import { setBanner } from "../globals/banner-data";
import { useLocation } from "react-router-dom";
import { getHeaderConfig } from "../globals/layout-config";
import React, { useEffect } from "react";
import { publicUser } from "../globals/route-names";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import AutoTranslateToFrench from "../components/AutoTranslateToFrench"

function CandidateLayout() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const currentpath = useLocation().pathname;

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            navigate(publicUser.pages.LOGIN);
        }
    }, [navigate]);

    return (
        <>
            <div className="page-wraper">

                <Header1 _config={getHeaderConfig(currentpath)} />

                <div className="page-content">

                    {/* <InnerPageBanner _data={setBanner(currentpath)} /> */}

                    <div className="section-full p-t120 p-b90 site-bg-white">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-3 col-lg-4 col-md-12 rightSidebar m-b30">
                                    <div className="side-bar-st-1">
                                        <CanSidebarSection />
                                    </div>
                                </div>
                                <div className="col-xl-9 col-lg-8 col-md-12 m-b30">
                                    {/* <div style={{display:'none'}}> */}
                                    {/* <AutoTranslateToFrench /> */}
                                    {/* </div> */}
                                    <CandidateRoutes />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <Footer1 />

                {/* BUTTON TOP START */}
                <button className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>

                <SignUpPopup />
                <SignInPopup />

                <YesNoPopup id="delete-dash-profile" type={popupType.DELETE} msg={"Do you want to delete your profile?"} />
                <YesNoPopup id="logout-dash-profile" type={popupType.LOGOUT} msg={`${t("Do you want to Logout your profile?")}`} />

            </div>
        </>
    )
}

export default CandidateLayout;